import React from 'react';

const Hero = ({homeData}) => {
  return (
    <section className="hero">
      <div className="row">
        <div className="col-md-6  order-2 order-md-1">
          <div className="container">
            <h1 className="ovlm-gradient-text">{homeData.title}</h1>
            <p>{homeData.short_text}</p>
            <a href={homeData.buttonUrl} className="btn btn-primary btn-lg mt-3 ovlm-gradient-bg">{homeData.buttonText}</a>
          </div>
        </div>
        <div className="col-md-6 order-1 order-md-2 d-none d-md-block">
          <div className="hero-bg">
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;